/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newplace1Inputs */

const en_newplace1 = /** @type {(inputs: Newplace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New place`)
};

const de_newplace1 = /** @type {(inputs: Newplace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Ort`)
};

/**
* | output |
* | --- |
* | "New place" |
*
* @param {Newplace1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const newplace1 = /** @type {((inputs?: Newplace1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newplace1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newplace1(inputs)
	return de_newplace1(inputs)
});
export { newplace1 as "newPlace" }